export interface ProduitStock {
  id: string;
  nom: string;
  type: string;
  couleur: string;
  quantiteStock: number;
  unite: string;
  seuilAlerte: number;
  prixUnitaire: number;
  fournisseur: string;
  image: string;
}

export const produitsMock: ProduitStock[] = [
  {
    id: 'p1',
    nom: 'Basin Riche Doré',
    type: 'Basin',
    couleur: 'Or/Beige',
    quantiteStock: 45,
    unite: 'mètres',
    seuilAlerte: 10,
    prixUnitaire: 4500,
    fournisseur: 'Tissus Coulibaly & Frères',
    image: 'https://readdy.ai/api/search-image?query=basin%20riche%20golden%20fabric%20African%20textile%20close%20up%20shiny%20embossed%20fabric%20texture%20warm%20gold%20beige%20color%20Mali&width=200&height=200&seq=prod001&orientation=squarish',
  },
  {
    id: 'p2',
    nom: 'Wax Hollandais Bleu',
    type: 'Wax',
    couleur: 'Bleu/Blanc',
    quantiteStock: 8,
    unite: 'mètres',
    seuilAlerte: 10,
    prixUnitaire: 3500,
    fournisseur: 'Marché Grand Marché',
    image: 'https://readdy.ai/api/search-image?query=wax%20hollandais%20blue%20white%20geometric%20pattern%20African%20fabric%20close%20up%20vibrant%20ankara%20textile&width=200&height=200&seq=prod002&orientation=squarish',
  },
  {
    id: 'p3',
    nom: 'Bogolan Naturel',
    type: 'Bogolan',
    couleur: 'Terre/Brun',
    quantiteStock: 32,
    unite: 'mètres',
    seuilAlerte: 8,
    prixUnitaire: 2800,
    fournisseur: 'Artisans de Ségou',
    image: 'https://readdy.ai/api/search-image?query=bogolan%20natural%20dyed%20African%20fabric%20brown%20beige%20geometric%20traditional%20Mali%20textile%20close%20up%20artisan&width=200&height=200&seq=prod003&orientation=squarish',
  },
  {
    id: 'p4',
    nom: 'Soie Importée Crème',
    type: 'Soie',
    couleur: 'Crème',
    quantiteStock: 5,
    unite: 'mètres',
    seuilAlerte: 6,
    prixUnitaire: 8500,
    fournisseur: 'Import Asie SARL',
    image: 'https://readdy.ai/api/search-image?query=silk%20fabric%20cream%20ivory%20smooth%20shiny%20imported%20textile%20close%20up%20luxury%20material%20neutral%20background&width=200&height=200&seq=prod004&orientation=squarish',
  },
  {
    id: 'p5',
    nom: 'Pagne Coton Multicolore',
    type: 'Pagne',
    couleur: 'Multicolore',
    quantiteStock: 60,
    unite: 'mètres',
    seuilAlerte: 15,
    prixUnitaire: 1800,
    fournisseur: 'Cotonaf Mali',
    image: 'https://readdy.ai/api/search-image?query=pagne%20coton%20multicolor%20African%20fabric%20pattern%20bright%20colors%20traditional%20west%20africa%20cotton%20textile%20close%20up&width=200&height=200&seq=prod005&orientation=squarish',
  },
  {
    id: 'p6',
    nom: 'Basin Léger Blanc',
    type: 'Basin',
    couleur: 'Blanc',
    quantiteStock: 28,
    unite: 'mètres',
    seuilAlerte: 10,
    prixUnitaire: 3200,
    fournisseur: 'Tissus Coulibaly & Frères',
    image: 'https://readdy.ai/api/search-image?query=basin%20blanc%20white%20fabric%20African%20light%20weight%20smooth%20clean%20texture%20Mali%20textile%20close%20up%20neutral%20background&width=200&height=200&seq=prod006&orientation=squarish',
  },
];

export const utilisateursMock = [
  { id: 'u0', nom: 'Admin Système', role: 'superadmin' as const, email: 'admin@atelierbassoum.ml', pin: '0000', avatar: 'AS', actif: true },
  { id: 'u1', nom: 'Dramane Konaté', role: 'gerant' as const, email: 'gerant@atelierbassoum.ml', pin: '1234', avatar: 'DK', actif: true },
  { id: 'u2', nom: 'Salimata Diarra', role: 'vendeur' as const, email: 'vendeur@atelierbassoum.ml', pin: '2345', avatar: 'SD', actif: true },
  { id: 'u3', nom: 'Kadidiatou Traoré', role: 'vendeur' as const, email: 'vendeur2@atelierbassoum.ml', pin: '2346', avatar: 'KT', actif: true },
  { id: 'u4', nom: 'Ibrahim Traoré', role: 'coupeur' as const, email: 'coupeur@atelierbassoum.ml', pin: '3456', avatar: 'IT', actif: true },
  { id: 'u5', nom: 'Seydou Coulibaly', role: 'coupeur' as const, email: 'coupeur2@atelierbassoum.ml', pin: '3457', avatar: 'SC', actif: true },
  { id: 'u6', nom: 'Moussa Diallo', role: 'tailleur' as const, email: 'tailleur@atelierbassoum.ml', pin: '4567', avatar: 'MD', actif: true },
  { id: 'u7', nom: 'Boubacar Diarra', role: 'tailleur' as const, email: 'tailleur2@atelierbassoum.ml', pin: '4568', avatar: 'BD', actif: true },
  { id: 'u8', nom: 'Souleymane Keita', role: 'responsable_atelier' as const, email: 'atelier@atelierbassoum.ml', pin: '5678', avatar: 'SK', actif: true },
];

export const roleLabels: Record<string, string> = {
  superadmin: 'Super Admin',
  gerant: 'Gérant',
  vendeur: 'Vendeur(se)',
  coupeur: 'Coupeur',
  tailleur: 'Tailleur',
  brodeur: 'Brodeur',
  responsable_atelier: 'Responsable Atelier',
};

export const roleIcons: Record<string, string> = {
  superadmin: 'ri-shield-star-line',
  gerant: 'ri-bar-chart-line',
  vendeur: 'ri-store-2-line',
  coupeur: 'ri-scissors-line',
  tailleur: 'ri-sewing-thread-line',
  brodeur: 'ri-quill-pen-line',
  responsable_atelier: 'ri-layout-grid-line',
};
